import React from 'react';
import styled from 'styled-components';
import { BaseLabel, RadioLabel } from '../../../../styles/styleUtils';

const Container = styled.div`
  display: flex;
  gap: 18px;
  margin-bottom: 15px;
  align-items: center;
  flex-wrap: wrap;
`;

const Option = styled.label`
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
`;

function TipoReceita({ value, onChange, disabled }) {
  return (
    <Container>
      <BaseLabel>Tipo de Receita</BaseLabel>

      <Option>
        <input
          type="radio"
          name="tipoReceita"
          value="avulsa"
          checked={value === 'avulsa'}
          onChange={onChange}
          disabled={disabled}
        />
        <RadioLabel>Avulsa</RadioLabel>
      </Option>

      <Option>
        <input
          type="radio"
          name="tipoReceita"
          value="parcelada"
          checked={value === 'parcelada'}
          onChange={onChange}
          disabled={disabled}
        />
        <RadioLabel>Parcelada</RadioLabel>
      </Option>

      <Option>
        <input
          type="radio"
          name="tipoReceita"
          value="recorrente"
          checked={value === 'recorrente'}
          onChange={onChange}
          disabled={disabled}
        />
        <RadioLabel>Recorrente</RadioLabel>
      </Option>
    </Container>
  );
}

export default TipoReceita;
